import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import axios from 'axios';
import { TabView, TabPanel } from 'primereact/tabview';
import ExcelUploader from "./ExcelUploader";
import CargarSlider from "../cargarSlider/CargarSlider";
import CargarNoticia from "../cargarNoticias/CargarNoticia";
import EditarNoticias from "../cargarNoticias/EditarNoticias";

function Administracion() {
    const auth = useAuth();
    const [userRole, setUserRole] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                const response = await axios.get(
                    `https://us-central1-inprojuy-f1173.cloudfunctions.net/app/users/${auth.id}/role`
                );
                setUserRole(response.data.role);
            } catch (error) {
                console.error("Error al obtener el rol del usuario:", error);
            }
        };
        fetchUserRole();
    }, [auth.id]);

    return (
        <div className="">
            <center>
                <h1 className="botonbordeazul text-white px-5 mx-5 py-3 h1">
                    Panel de Control
                </h1>
            </center>

            {userRole === "admin" && (
                <div
                    id="panel"
                    style={{
                        border: '1px solid #000',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        padding: '10px',
                        borderRadius: '5px'
                    }}
                >
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                        <TabPanel header="Cargar Slider">
                            <CargarSlider />
                        </TabPanel>
                        <TabPanel header="Cargar Noticia">
                            <CargarNoticia />
                        </TabPanel>
                        <TabPanel header="Editar Noticias">
                            <EditarNoticias />
                        </TabPanel>
                        <TabPanel header="Cargar Empleados">
                            <ExcelUploader />
                        </TabPanel>
                    </TabView>
                </div>
            )}

            <div>

            </div>

        </div>
    );
}

export default Administracion;
